import React from "react"
import CurrencyContext from "../../context/CurrencyContext"

const PricingTld = ({ pricing, tld }) => {
  return (
    <CurrencyContext.Consumer>
      {(context) => {
        if (!pricing || !tld) {
          return null; // Handle cases where pricing or tld is undefined/null
        }

        let currencySymbol;
        let currency;
        switch (context.defaultValue) {
          case "USD":
            currencySymbol = "$";
            currency = pricing.USD;
            break;
          case "INR":
            currencySymbol = "\u20b9";
            currency = pricing.INR;
            break;
          case "GBP":
            currencySymbol = "\u00a3";
            currency = pricing.GBP;
            break;
          default:
            currencySymbol = "\u20b9";
            currency = pricing.INR;
        }

        const percentageDifference =
          currency.register !== 0
            ? ((currency.renew - currency.register) / currency.register) * 100
            : 0;

        return (
          <>
            Get a {tld} for&nbsp;
            <strike>
              {currencySymbol}&nbsp;{currency.renew}
            </strike>{" "}
            {currencySymbol}&nbsp;
            {currency.register}
            {/* Display the percentage difference */}
            <div className="badge position-absolute bg-main fs-14" style={{ top: -4, right: -4 }}>
              {percentageDifference.toFixed(2)}%
            </div>
          </>
        );
      }}
    </CurrencyContext.Consumer>
  );
};

export default PricingTld;
